import { CHAT_CONTACT_LIST_MESSAGES, ChatContactListMessages } from "./contact-list.messages";
import { CURRENT_CHAT_MESSAGES, CurrentChatMessages } from "./current-chat.messages";
import {
  WHATSAPP_ACCOUNT_INFO_MESSAGES,
  WhatsAppAccountInfoMessages,
} from "./whatsapp-account-info.messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";

export type ChatMessages = SidebarMessages &
  ActionButtonMessages &
  CurrentChatMessages &
  ChatContactListMessages &
  WhatsAppAccountInfoMessages & {
    chatTitle: string;
    chatBreadCrumbTitle: string;
    errorToLoadChatTitle: string;
    errorToLoadChatAlt: string;
    contactPanelTitle: string;
    contactPanelEmptySelection: string;
    contactPanelNoContact: string;
    contactPanelNicknameLabel: string;
    contactPanelNameLabel: string;
    contactPanelPhoneLabel: string;
    contactPanelEmailLabel: string;
    contactPanelTagsLabel: string;
    contactPanelOrdersTitle: string;
    contactPanelNoOrders: string;
    contactPanelActionsTitle: string;
    contactPanelTransferTitle: string;
    contactPanelOrderLabel: string;
    contactPanelExpand: string;
    contactPanelCollapse: string;
    contactPanelCopy: string;
    contactPanelCopySuccess: string;
    contactPanelCopyError: string;
    contactPanelOpenContact: string;
    openingConversation: string;
  };

export const CHAT_MESSAGES: ChatMessages = {
  chatTitle: "Conversas",
  chatBreadCrumbTitle: "Conversas",
  errorToLoadChatTitle: "Erro ao carregar chats",
  errorToLoadChatAlt: "Imagem de erro ao carregar chats",
  contactPanelTitle: "Dados do contato",
  contactPanelEmptySelection: "Selecione uma conversa para ver os dados do contato.",
  contactPanelNoContact: "Contato",
  contactPanelNicknameLabel: "Apelido",
  contactPanelNameLabel: "Nome",
  contactPanelPhoneLabel: "Telefone",
  contactPanelEmailLabel: "e-mail",
  contactPanelTagsLabel: "Etiquetas",
  contactPanelOrdersTitle: "Últimos pedidos",
  contactPanelNoOrders: "Nenhum pedido encontrado.",
  contactPanelActionsTitle: "Ações conversacionais",
  contactPanelTransferTitle: "Transferência de etapa",
  contactPanelOrderLabel: "Pedido",
  contactPanelExpand: "Expandir dados do contato",
  contactPanelCollapse: "Recolher dados do contato",
  contactPanelCopy: "Copiar",
  contactPanelCopySuccess: "Copiado para a área de transferência",
  contactPanelCopyError: "Não foi possível copiar",
  contactPanelOpenContact: "Abrir contato",
  openingConversation: "Abrindo conversa...",

  ...WHATSAPP_ACCOUNT_INFO_MESSAGES,
  ...CURRENT_CHAT_MESSAGES,
  ...CHAT_CONTACT_LIST_MESSAGES,
  ...SIDEBAR_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
};
// no default export
